export default function (cli) {
  return {
    all (fn) {
      let holidays = []
      let request = url => {
        return cli.get(url).then(res => {
          holidays = holidays.concat(res.body.results)
          if (res.body.next) {
            return request(res.body.next)
          } else {
            return holidays
          }
        })
      }
      return request(`${cli.crmApiEndpoint}holidays/`).then(fn)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/holidays.js